module.exports = __webpack_public_path__ + "static/media/IMG_E2889a.3a0a5941.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/andes/IMG_E2889a.jpg
// module id = 160
// module chunks = 0